import { createAction } from 'redux-actions'
import { NAV_REQUEST, NAV_REQUEST_FAILED, NAV_REQUEST_SUCCEEDED } from 'Redux/Types/NavTypes'

export const navigate = createAction(NAV_REQUEST)
export const navigationFailed = createAction(NAV_REQUEST_FAILED)
export const navigationSucceeded = createAction(NAV_REQUEST_SUCCEEDED)
